import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/personafitscorebar.scss';


export default class PersonaFitScoreBar extends Component {
    render() {
        const { outerWidth, innerWidth, height, score, classes } = this.props;
        const displayedScore = (score || score === 0) ? <span>{ `${score}%` }</span> : null;

        return (
            <div className={ `${style.scoreAttachmentWidgetScoreBar} ${classes.root}` }>
                <svg>
                    <g>
                        <rect
                            rx="8"
                            ry="8"
                            x="0"
                            y="0"
                            width={ outerWidth }
                            height={ height }
                            className={ `${style.scoreBarOutside} ${classes.scoreBarOutside}` }
                        />
                        <rect
                            rx="8"
                            ry="8"
                            x="0"
                            y="0"
                            width={ innerWidth }
                            height={ height }
                            className={ `${style.scoreBarInside} ${classes.scoreBarInside}` }
                        />
                    </g>
                </svg>
                { displayedScore }
            </div>
        );
    }
}

PersonaFitScoreBar.propTypes = {
    outerWidth: PropTypes.string,
    innerWidth: PropTypes.string,
    height: PropTypes.string,
    score: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    classes: PropTypes.shape({
        root: PropTypes.string,
        scoreBarOutside: PropTypes.string,
        scoreBarInside: PropTypes.string
    })
};

PersonaFitScoreBar.defaultProps = {
    outerWidth: '100%',
    innerWidth: '0%',
    height: '15px',
    score: null,
    classes: {
        root: '',
        scoreBarOutside: '',
        scoreBarInside: ''
    }
};
